import { getUserInfo } from "../../../services/localStorage";

function resolveAgentPostSessionIdSync() {
  try {
    const u = getUserInfo();
    const fromUser = u?.sessionID ?? u?.sessionId;
    if (fromUser != null && String(fromUser).trim() !== "") {
      return String(fromUser).trim();
    }
  } catch {
    /* ignore */
  }
  if (typeof localStorage !== "undefined") {
    const ls = localStorage.getItem("sessionID");
    if (ls != null && String(ls).trim() !== "") {
      return String(ls).trim();
    }
  }
  return "";
}

/** Same contract as fhpService `_attachAgentSessionToBody` — keeps module API independent. */
export function attachAgentSessionToBody(data) {
  if (
    typeof localStorage === "undefined" ||
    data == null ||
    typeof data !== "object" ||
    Array.isArray(data)
  ) {
    return data;
  }
  const sid = resolveAgentPostSessionIdSync();
  if (sid === "") {
    return data;
  }
  return { ...data, sessionID: sid };
}
